import { Outlet, RouteObject } from "react-router-dom";

import Complaints from "@/features/applications/complaints/pages/complaints.tsx";
import ComplaintsDetail from "./fragments/complaints-details";


const routes: RouteObject = {
    path: "complaints",
    element: <Outlet />,
    children: [
        {
            index: true,
            element: <Complaints />,
        },
        {
            path: "",
            element: <Complaints />,
            children: [
                {
                    path: ":id",
                    element: <ComplaintsDetail />
                }
            ]
        },
    ]
}

export default routes